<template>
  <vs-popup class="holamundo my-order-invoice" title="View Invoice" :active.sync="config.isOpen">
    <vx-card
      class="w-11/12 mx-auto p-6 view-invoice-card offset-3 col-6"
      id="download-invoice"
      ref="document"
    >
      <div>
        <div class="text-center my-base">
          <h3 class="font-bold">Invoice for order #{{order.order_code}}</h3>
          <p
            class="pt-2 text-grey-custom"
            style="color: #9198a0"
          >{{changeFormatDate(order.invoice.created_at)}}</p>
        </div>

        <div
          class="invoice-items border-top border-top-custom"
          v-for="(item,index) in order.order_items"
          :key="index"
          style="padding-top: 1.5rem; padding-bottom: 1.5rem"
        >
          <div
            v-if="item!== undefined && item.item_name != '' && item.price != null"
            class="d-flex justify-content-between align-items-center flex justify-between align-center"
          >
            <div>
              <div
                class="p-0 text-lg font-bold font-weight-bold"
              >{{item.item_name}} x {{item.quantity}}</div>
            </div>
            <div class="text-lg font-bold font-weight-bold">${{parseFloat(item.price * item.quantity).toFixed(2)}}</div>
          </div>
        </div>

        <div
          class="invoice-items border-top border-top-custom"
          style="padding-top: 1.5rem; padding-bottom: 1.5rem"
        >
          <div
            class="d-flex justify-content-between align-items-center flex justify-between align-center text-lg font-bold font-weight-bold"
          >
            <div>Total</div>
            <div>${{(order.invoice.total_after_tax).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
          </div>
        </div>

        <div
          class="invoice-items border-top border-top-custom"
          style="padding-top: 1.5rem; padding-bottom: 1.5rem"
        >
          <div
            class="d-flex justify-content-between align-items-center flex justify-between align-center"
          >
            <div>
              <div
                class="p-0 text-lg font-bold font-weight-bold"
              >Pay by: {{(order.invoice.payment_method)== 'credit_card' ? 'Credit card' : 'Cash'}}</div>
              <div
                class="p-0 text-grey-custom"
                style="color: #9198a0"
              >{{changeFormatDateTime(order.invoice.created_at)}}</div>
            </div>
            <div
              class="text-lg font-bold font-weight-bold"
            >${{(order.invoice.total_after_tax).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
          </div>
        </div>

        <!-- <div
          class="invoice-items border-top border-top-custom"
          style="padding-top: 1.5rem; padding-bottom: 1.5rem"
        >
          <div
            class="d-flex justify-content-between align-items-center flex justify-between align-center text-lg font-bold font-weight-bold"
          >
            <div>Balance</div>
            <div>$0</div>
          </div>
        </div>-->
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import moment from "moment";

export default {
  name: "order-invoice",
  props: {
    config: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeFormatDate(day) {
      if(day) {
        return moment(day).format("MMMM Do YYYY");
      } else {
        return 'N/A';
      }
    },
    changeFormatDateTime(day) {
      if(day) {
        return moment(day).format("LLLL");
      } else {
        return 'N/A';
      }
    }
  },
  created() {}
};
</script>